import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled, keyframes } from 'styled-components';
import SvgChevron from '../../../../../play-core/icons/Chevron';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Fonts } from '../../../../../play-core/styles/Fonts';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { zIndex } from '../../../../../play-core/styles/z-index';
import { useAnalyticsDispatch } from '../../../analytics/AnalyticsContext';
import { IconWrapper } from '../../../components/IconWrapper/IconWrapper';
import { defaultSegmentHeight } from '../../../components/Letterbox/Letterbox.constants';
import { useScrollYPosition } from '../../../hooks/use-scroll-position';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ScrollForMoreButton = ({
  visible,
  hasSegments = false
}) => {
  const {
    t
  } = useTranslation();
  const y = useScrollYPosition();
  const analytics = useAnalyticsDispatch();
  return /*#__PURE__*/_jsxs(StyledButton, {
    className: visible && y === 0 ? 'fade-in' : 'fade-out',
    onClick: () => {
      analytics({
        type: 'click-event',
        name: 'ScrollForDetailsClick',
        value1: window.document.title
      });
      window.scrollTo({
        top: 400,
        behavior: 'smooth'
      });
    },
    hasSegments: hasSegments,
    children: [/*#__PURE__*/_jsx(StyledText, {
      children: t('global.scrollForMore')
    }), /*#__PURE__*/_jsx(StyledIconWrapper, {
      icon: /*#__PURE__*/_jsx(SvgChevron, {
        orientation: "down"
      })
    })]
  });
};
const fadeOut = keyframes(["100%{opacity:0;display:none;}"]);
const fadeIn = keyframes(["0%{opacity:0;}100%{opacity:1;}"]);
const StyledButton = styled.button.withConfig({
  displayName: "ScrollForMoreButton__StyledButton",
  componentId: "sc-xvoshv-0"
})(["transition-property:all;transition-duration:0.5s;color:", ";width:fit-content;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;position:absolute;left:50%;transform:translateX(-50%);padding-bottom:16px;bottom:", ";z-index:", ";", ";", "{", ";}", "{", ";}&.fade-out{animation:", " 0.5s forwards;}&.fade-in{animation:", " 0.5s forwards;}"], Colors.WHITE, ({
  hasSegments
}) => hasSegments ? `${defaultSegmentHeight}px` : 0, zIndex.abovePlayer, Fonts.medium(16, 'interactive'), Viewports.for('large'), Fonts.medium(14, 'interactive'), Viewports.for('medium'), Fonts.medium(12, 'interactive'), fadeOut, fadeIn);
const StyledIconWrapper = styled(IconWrapper).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "ScrollForMoreButton__StyledIconWrapper",
  componentId: "sc-xvoshv-1"
})(["font-size:inherit;"]);
const StyledText = styled.span.withConfig({
  displayName: "ScrollForMoreButton__StyledText",
  componentId: "sc-xvoshv-2"
})(["", "{display:none;}"], Viewports.for('small'));